import axios from 'axios';

export default {
  fetchContacts(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/contacts/", {params})
      .then(results=>{
        return results.data;
      })
  },
  deleteContact(contactId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/contacts/" + contactId)
      .then(results=>{
        return results.data;
      })
  }

}
